import React from 'react';
import * as S from './bagCancelRules.styles';
import * as S1 from '../common-elements.styles';
import { CarrierLogo } from '../common-elements.styles';
import { getPriceString } from '@stencil/flights-utils/src/srp-thor-utils';

export function FareDetails({ flightItem }) {
  if (
    flightItem.priceBreakup.base === null ||
    flightItem.priceBreakup.tax == null ||
    flightItem.priceBreakup.total === null
  ) {
    return null;
  }
  return (
    <div className="pad10 padB20">
      <S.Cstable className="font12 tableFare">
        <S.Csrow>
          <div className="cscell">
            <span className="fl">Base Fare (1 Adult)</span>
          </div>
          <div className="cscell">₹{flightItem.priceBreakup.base}</div>
        </S.Csrow>
        <S.Csrow>
          <div className="cscell">
            <span className="fl">Taxes and Fees (1 Adult)</span>
          </div>
          <div className="cscell">₹{flightItem.priceBreakup.tax}</div>
        </S.Csrow>
        <S.Csrow>
          <div className="cscell">
            <span className="fl fb">Total Fare (1 Adult)</span>
          </div>
          <div className="cscell fb">₹{flightItem.priceBreakup.total}</div>
        </S.Csrow>
      </S.Cstable>
    </div>
  );
}

export function BaggageRules({ baggageData }) {
  if (!baggageData) {
    return (
      <div className="padT20">
        <S1.SpinnerLoader />
      </div>
    );
  }
  return (
    <>
      {Object.keys(baggageData).map(key => (
        <div className="pad10 baggage" key={'baggage_' + key}>
          <div className="padB20 dF alignItemsCenter">
            <CarrierLogo
              src={`https://imgak.goibibo.com/flights-gi-assets/images/v2/app-img/${baggageData[key].carrierid}.png`}
              alt="Flights"
            />
            <span className="font13 padT3 fb black quicksand">{key}</span>
            <span className="padT5 font11 padL5">
              ({baggageData[key].carrierid}-{baggageData[key].flightno})
            </span>
          </div>
          {baggageData[key]?.terms?.map((bag, i) => (
            <S.Cstable className="font12 baggage" key={'bagRule_' + i}>
              <S.Csrow>
                <span className="cscell bg-greyLtest2 width30">{bag?.bt?.name}</span>
                <span className="cscell width35">{bag?.cb?.name}</span>
                <span className="cscell width35">{bag?.hb?.name}</span>
              </S.Csrow>
              <S.Csrow>
                <span className="cscell bg-greyLtest2 width30">{bag?.bt?.value}</span>
                <span className="cscell width35">{bag?.cb?.value}</span>
                <span className="cscell width35">{bag?.hb?.value}</span>
              </S.Csrow>
            </S.Cstable>
          ))}
          {baggageData[key]?.tnc?.map((tnc, i) => (
            <p className="font11 padT10 lh1-5" key={'tnc_' + i}>
              * {tnc}
            </p>
          ))}
        </div>
      ))}
    </>
  );
}

export function CancellationRules({ rulesData, refundability }) {
  if (!rulesData || !rulesData.terms) {
    return (
      <div className="padT20">
        <S1.SpinnerLoader />
      </div>
    );
  }
  return (
    <>
      {Object.keys(rulesData.terms).map(key => (
        <S.CancellationRules className="pad10" key={'rules_' + key}>
          <div className="padB20 dF alignItemsCenter">
            <CarrierLogo
              src={`https://imgak.goibibo.com/flights-gi-assets/images/v2/app-img/${rulesData.terms[key].cr}.png`}
              alt="Flights"
            />
            <span className="font13 padT3 fb black quicksand padR10">{key}</span>
            {refundability ? (
              <S.Refundability
                isRefundable={refundability.toLowerCase().indexOf('non') === -1 ? true : false}
                className="fb white"
              >
                {refundability?.toUpperCase()}
              </S.Refundability>
            ) : null}
            {/* <span className="padT4 font11 padL2">(I5 996)</span> */}
          </div>
          <div className="width100 clr">
            {rulesData.terms[key].cp &&
              rulesData.terms[key].cp.value &&
              Object.keys(rulesData.terms[key].cp.value).length > 0 && (
                <S.Cstable className="font12 tableFare">
                  <div className="black padB10">{rulesData.terms[key].cp?.name}</div>
                  {rulesData.terms[key]?.cp?.value &&
                    Object.keys(rulesData.terms[key].cp.value).map(type => (
                      <S.Csrow key={'cp_row_' + type}>
                        <div className="cscell">
                          <span className="fl">{rulesData.terms[key].cp.value[type].name}</span>
                        </div>
                        <div className="cscell">
                          {isNaN(rulesData.terms[key].cp.value[type].value) ? (
                            rulesData.terms[key].cp.value[type].value
                          ) : (
                            <span>
                              ₹{getPriceString(rulesData.terms[key].cp.value[type].value)}
                            </span>
                          )}
                        </div>
                      </S.Csrow>
                    ))}
                </S.Cstable>
              )}
            {rulesData.terms[key].rp &&
              rulesData.terms[key].rp.value &&
              Object.keys(rulesData.terms[key].rp.value).length > 0 && (
                <S.Cstable className="font12 tableFare">
                  <div className="black padB10">{rulesData.terms[key].rp?.name}</div>
                  {rulesData.terms[key]?.rp?.value &&
                    Object.keys(rulesData.terms[key].rp.value).map(type => (
                      <S.Csrow key={'rp_row_' + type}>
                        <div className="cscell">
                          <span className="fl">{rulesData.terms[key].rp.value[type].name}</span>
                        </div>
                        <div className="cscell">
                          {isNaN(rulesData.terms[key].rp.value[type].value) ? (
                            rulesData.terms[key].rp.value[type].value
                          ) : (
                            <span>
                              ₹{getPriceString(rulesData.terms[key].rp.value[type].value)}
                            </span>
                          )}
                        </div>
                      </S.Csrow>
                    ))}
                </S.Cstable>
              )}
          </div>
          <p className="font11 padT10 width100 clr"></p>
        </S.CancellationRules>
      ))}
    </>
  );
}

export default FareDetails;
